import { types as sdkTypes } from './sdkLoader';

const { Money } = sdkTypes;

export const DISTRIBUTOR_PRICE = 'distributor';
export const FOUNDER_PRICE = 'founder';

const NO_SPECIAL_PRICE = { price: null, priceType: null };

const toMoney = raw =>
  raw?.amount != null && raw?.currency ? new Money(raw.amount, raw.currency) : null;

/**
 * Picks the pricing related flags from the current user's profile metadata.
 *
 * @param {Object} currentUser API entity: current user
 * @returns {{isDistributor: boolean, isFounder: boolean}}
 */
export const getPricingFlags = currentUser => {
  const { isDistributor, isFounder } = currentUser?.attributes?.profile?.metadata || {};
  return { isDistributor: !!isDistributor, isFounder: !!isFounder };
};

/**
 * Resolves the discounted price the user is entitled to for a single listing.
 * A user can be flagged both as a distributor and as a founding member, in
 * which case the cheaper of the two configured prices wins.
 *
 * @param {Object} publicData listing's publicData
 * @param {{isDistributor: boolean, isFounder: boolean}} pricingFlags
 * @returns {{price: Money|null, priceType: string|null}}
 */
export const getSpecialPrice = (publicData, pricingFlags) => {
  const { isDistributor, isFounder } = pricingFlags || {};

  const candidates = [
    isDistributor
      ? { price: toMoney(publicData?.distributorPrice), priceType: DISTRIBUTOR_PRICE }
      : null,
    isFounder ? { price: toMoney(publicData?.founderPrice), priceType: FOUNDER_PRICE } : null,
  ].filter(candidate => !!candidate?.price);

  return (
    candidates.reduce(
      (best, candidate) => (!best || candidate.price.amount < best.price.amount ? candidate : best),
      null
    ) || NO_SPECIAL_PRICE
  );
};

/**
 * Label shown next to a discounted price.
 *
 * @param {string|null} priceType
 * @returns {string|null}
 */
export const getSpecialPriceLabel = priceType =>
  priceType === DISTRIBUTOR_PRICE
    ? 'Distributor price'
    : priceType === FOUNDER_PRICE
    ? 'Founding member price'
    : null;
